import React from 'react'
import { StyledIcon, StyledIconProps } from './styled-icon'

export function CsConfirmationIcon(props: StyledIconProps) {
  return (
    <StyledIcon viewBox="0 0 416 419" {...props}>
      <g>
        <path d="M352 232.5V312c0 19.8-7 36.8-21.1 50.9S299.8 384 280 384H72c-19.8 0-36.8-7-50.9-21.1S0 331.8 0 312V104c0-19.8 7-36.8 21.1-50.9S52.2 32 72 32h208c10.5 0 20.2 2.1 29.2 6.2 2.5 1.2 4 3.1 4.5 5.8.5 2.8-.2 5.2-2.2 7.2l-12.2 12.2c-1.7 1.7-3.6 2.5-5.8 2.5-.5 0-1.2-.2-2.2-.5-3.8-1-7.6-1.5-11.2-1.5H72c-11 0-20.4 3.9-28.2 11.8S32 93 32 104v208c0 11 3.9 20.4 11.8 28.2S61 352 72 352h208c11 0 20.4-3.9 28.2-11.8S320 323 320 312v-63.5c0-2.2.8-4 2.2-5.5l16-16c1.7-1.7 3.6-2.5 5.8-2.5 1 0 2 .2 3 .8 3.3 1.3 5 3.7 5 7.2zm57.8-122.3L206.2 313.8c-4 4-8.8 6-14.2 6s-10.2-2-14.2-6L70.2 206.2c-4-4-6-8.8-6-14.2s2-10.2 6-14.2l27.5-27.5c4-4 8.8-6 14.2-6s10.2 2 14.2 6L192 216 353.8 54.2c4-4 8.8-6 14.2-6s10.2 2 14.2 6l27.5 27.5c4 4 6 8.8 6 14.2s-1.9 10.3-5.9 14.3z" />
      </g>
    </StyledIcon>
  )
}
